import { ADD_CAFE_PASS, CLEAR_CAFE_PASS, SET_ACTIVE_PASS } from "../actions";

export const INITIAL_STATE = { cafePassList: [], activePass: {} };
export const cafePassReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_CAFE_PASS: {
      const newPassList = state.cafePassList.concat(action.payload);
      const newObject = { ...state };
      newObject.cafePassList = newPassList;
      return newObject;
    }
    case CLEAR_CAFE_PASS: {
      return INITIAL_STATE;
    }
    case SET_ACTIVE_PASS: {
      const newObject = { ...state };
      newObject.activePass = action.payload;
      return newObject;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/cafePass.js